import { Headings, HeadingVariants } from '../Headings';
import { Container, Flex } from '../Layout';
import { Text } from '../Text';
import { Colors } from '../../utils';
import { DateWithDots } from '../DateWithDots';

export const DateRangeItemDetails = ({
  title,
  subTitle,
  startDate,
  endDate,
  description,
  terminology = 'startEnd',
  backgroundColor = 'white',
  headingComponent = 'H4',
  headingStyle,
  subTitleComponent,
  subTitleStyle,
}: {
  title?: string;
  subTitle: string;
  description?: string;
  startDate?: string;
  endDate?: string | null;
  terminology?: 'startEnd' | 'validFromTo';
  backgroundColor?: Colors;
  headingComponent?: keyof typeof Headings;
  headingStyle?: HeadingVariants;
  subTitleComponent?: keyof typeof Headings;
  subTitleStyle?: HeadingVariants;
}): JSX.Element => {
  const Heading = Headings[headingComponent];
  const SubTitleHeading = Headings[subTitleComponent ?? 'H5'];

  return (
    <Container backgroundColor={backgroundColor}>
      {title && (
        <Heading styleAs={headingStyle} marginBottom={6} color="black90">
          {title}
        </Heading>
      )}
      <Flex backgroundColor={backgroundColor} flexDirection="column" rowGap={10}>
        {subTitleComponent ? (
          <SubTitleHeading styleAs={subTitleStyle}>{subTitle}</SubTitleHeading>
        ) : (
          <Text size="small" color="black90">
            {subTitle}
          </Text>
        )}

        {description && (
          <Text size="xs" color="black70">
            {description}
          </Text>
        )}
        {startDate && (
          <DateWithDots
            text={terminology === 'validFromTo' ? 'Giltig från och med' : 'Startdatum'}
            date={startDate}
            backgroundColor={backgroundColor}
          />
        )}
        {endDate && (
          <DateWithDots
            text={terminology === 'validFromTo' ? 'Till och med' : 'Slutdatum'}
            date={endDate}
            backgroundColor={backgroundColor}
          />
        )}
      </Flex>
    </Container>
  );
};
